import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useTeam } from "@/lib/team";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import ListerProgress from "@/pages/batch/ListerProgress";
import { duration } from "@/pages/TeamPage";

// Owner-only: celebrate each sent-to-lister batch that's fully listed (Pac-Man replays the run and eats the logo).
export default function BatchDoneAlert() {
  const { isAssistant } = useTeam();
  const navigate = useNavigate();
  const [alerts, setAlerts] = useState([]);
  const [step, setStep] = useState(0);
  const a = alerts[0];

  const load = useCallback(() => {
    api.get("/photo-batches/done-alerts").then(({ data }) => setAlerts(data.alerts || [])).catch(() => {});
  }, []);
  useEffect(() => {
    if (isAssistant !== false) return undefined;
    load();
    const t = setInterval(() => { if (!document.hidden) load(); }, 5 * 60000);
    window.addEventListener("focus", load);
    return () => { clearInterval(t); window.removeEventListener("focus", load); };
  }, [isAssistant, load]);
  useEffect(() => {
    if (!a) return undefined;
    setStep(0);
    const per = Math.max(60, Math.min(250, 1800 / a.items));
    const t = setInterval(() => setStep((s) => (s >= a.items ? s : s + 1)), per);
    return () => clearInterval(t);
  }, [a]);

  if (!a) return null;
  const close = (open) => {
    if (open) return;
    api.post(`/photo-batches/${a.id}/done-seen`).catch(() => {});
    setAlerts((l) => l.slice(1));
  };
  return (
    <Dialog open onOpenChange={close}>
      <DialogContent className="w-[calc(100%-1.5rem)] max-w-sm rounded-2xl bg-slate-950 text-white" data-testid="batch-done-alert">
        <DialogTitle className="font-['Space_Grotesk'] text-xl">Batch finished!</DialogTitle>
        <DialogDescription className="text-sm text-slate-300" data-testid="batch-done-text">
          <b className="text-white">{a.by}</b> listed all {a.items} item{a.items === 1 ? "" : "s"} in <b className="text-white">“{a.name}”</b> in {duration(a.secs)}.
        </DialogDescription>
        <div className="rounded-xl bg-slate-800 px-3 py-2 [&_.lp-track]:bg-slate-950 [&_.text-slate-500]:text-slate-400 [&_.text-slate-800]:text-white">
          <ListerProgress listed={step} total={a.items} name={a.by} testid="batch-done-pacman" />
        </div>
        <div className="flex gap-2">
          <Button variant="outline" className="flex-1 rounded-full border-slate-600 bg-transparent text-white hover:bg-slate-800 hover:text-white"
            onClick={() => { close(false); navigate(`/batch?b=${a.id}`); }} data-testid="batch-done-open">See batch</Button>
          <Button className="flex-1 rounded-full bg-[#facc15] font-semibold text-slate-900 hover:bg-[#eab308]" onClick={() => close(false)} data-testid="batch-done-dismiss">
            Nice!
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
